// extracted by mini-css-extract-plugin
module.exports = {"BigCard":"BigCard_BigCard__Z2Pgd"};